@if (showPeriodSelector) {
  <div
    class="row start-center period-selector-container"
    id="targetElement"
    >
    @if (canNavigate) {
      <div
        class="row center-center justify-space-around period-selector-row custom-period"
        >
        <button
          [disabled]="canGoBackward === false"
          (click)="onBackwardButtonClicked()"
          class="button transparent icon"
          >
          <ion-icon name="chevron-back-outline" class="period-selector-chevron"></ion-icon>
        </button>
        <div>{{ formattedDate }}</div>
        <button
          [disabled]="canGoForward === false"
          (click)="onForwardButtonClicked()"
          class="button transparent icon"
          >
          <ion-icon name="chevron-forward-outline" class="period-selector-chevron"></ion-icon>
        </button>
      </div>
      <div class="first-vertical-line"></div>
    }
    @for (periodSelectorItem of visiblePeriodSelectorItems; track periodSelectorItem) {
      <button
        class="period-selector__button"
      [ngClass]="
        periodSelectorItem.isActive === true
          ? 'period-selector__button--active'
          : 'period-selector__button--inactive'
      "
        (click)="onPeriodSelectorButtonClick(periodSelectorItem.interval)"
        >
        {{ periodSelectorItem.name }}
      </button>
    }
    @if (hasCustomPeriod) {
      <button
        [ngClass]="isCustomPeriodSelected === true ? 'primary' : 'secondary'"
        class="item button icon column center-center"
        (click)="onCustomPeriodSelectorButtonClick()"
        >
        <i class="ri-icon icon rif-calendar"></i>
      </button>
    }
  </div>
}

<dx-popup
  class="custom-popup"
  [(width)]="width"
  height="auto"
  [dragEnabled]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="popupVisible"
  [deferRendering]="false"
  (onHiding)="onCustomPeriodSelectorHidding()"
  >
  <dxo-position
    my="right top"
    at="right top"
    offset="+0 +53"
    of="#targetElement"
    >
  </dxo-position>
  <form
    [formGroup]="customPeriodSelectionForm"
    (ngSubmit)="saveSelectedCustomPeriod()"
    class="column justify-space-between grow popup-form"
    >
    <div class="column justify-space-around grow">
      <div class="row justify-space-between start-center item grow">
        <label>
          <h4>{{ "Shell.generic.startDate" | translate }}:</h4>
        </label>
        <div>
          <dx-date-box
            [width]="146"
            [showClearButton]="true"
            [useMaskBehavior]="true"
            [displayFormat]="userDateFormat"
            type="date"
            formControlName="startDate"
            #userStartDateBox
            >
          </dx-date-box>
        </div>
      </div>
      @if (startDateRequiredError) {
        <div class="row start-center item new-period-selector-custom-error">
          <span>{{
            "Shell.generic.mandatoryField"
            | translate: { fieldName: "Shell.generic.startDate" | translate }
          }}</span>
        </div>
      }
      <div class="row justify-space-between start-center item grow">
        <label>
          <h4>{{ "Shell.generic.endDate" | translate }}:</h4>
        </label>
        <div>
          <dx-date-box
            [width]="146"
            [showClearButton]="true"
            [useMaskBehavior]="true"
            [displayFormat]="userDateFormat"
            type="date"
            formControlName="endDate"
            [min]="startDateControl.value"
            >
          </dx-date-box>
        </div>
      </div>
      @if (endDateRequiredError) {
        <div class="row start-center item new-period-selector-custom-error">
          <span>{{
            "Shell.generic.mandatoryField"
            | translate: { fieldName: "Shell.generic.endDate" | translate }
          }}</span>
        </div>
      }
      @if (startDateGreaterThanEndDateError) {
        <div class="row start-center item new-period-selector-custom-error">
          <span>{{
            "Shell.newOrganizations.pages.cropCycles.startDateGreaterThanEndDate"
            | translate
          }}</span>
        </div>
      }
    </div>
    <div class="row justify-space-between item grow period-selector-popup-buttons-padding">
      <div>
        <button
          class="button-primary"
          type="submit"
          [disabled]="customPeriodSelectionForm.invalid"
          >
          {{ "Shell.generic.apply" | translate }}
        </button>
      </div>
      <div>
        <button
          class="button-secondary cancel"
          (click)="hideCustomPeriodSelector($event)"
          type="button"
          >
          {{ "Shell.generic.cancel" | translate }}
        </button>
      </div>
    </div>
  </form>
</dx-popup>
